import { useDispatch, useSelector } from "react-redux";
import { Badge, Button, Row, Col } from "reactstrap";
import {
  setWorkModeFilter,
  setLocationFilter,
  setJobTypeFilter,
  setPageNumber,
  resetJobPortalJobList,
  fetchJobPortalJobList,
  fetchJobPortalWorkLocations,
} from "../../../store/job/action";

export default function FilterBubble() {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.JobPortalJobReducer.filter);
  const { workModes, locations, salaryMin, salaryMax, jobTypes } = filter;

  // Check if filters are active
  function checkFilterActive() {
    return workModes.length > 0 || locations.length > 0 || jobTypes.length > 0;
  }

  // Clear filter bubbles
  function handleClear(title) {
    switch (title) {
      case "locations":
        dispatch(setLocationFilter([]));
        break;
      case "workModes":
        dispatch(setWorkModeFilter([]));
        break;
      case "jobTypes":
        dispatch(setJobTypeFilter([]));
        break;
      default:
        dispatch(setLocationFilter([]));
        dispatch(setWorkModeFilter([]));
        dispatch(setJobTypeFilter([]));
        break;
    }

    dispatch(setPageNumber(0))
      .then(() => dispatch(resetJobPortalJobList()))
      .then(() => dispatch(fetchJobPortalJobList(0)))
      .then(() => dispatch(fetchJobPortalWorkLocations()));
  }

  return (
    <Row className="filterbubble-container">
      {workModes.length > 0 && (
        <Col xs="auto">
          <Badge pill>
            <h6>Work Mode:</h6>
            {workModes.map((mode, index) => (
              <p key={index}>
                {mode} {index < workModes.length - 1 && <span>,</span>}
              </p>
            ))}
            <Button onClick={() => handleClear("workModes")}>X</Button>
          </Badge>
        </Col>
      )}
      {locations.length > 0 && (
        <Col xs="auto">
          <Badge pill>
            <h6>Location:</h6>
            {locations.map((loc, index) => (
              <p key={index}>
                {loc} {index < locations.length - 1 && <span>,</span>}
              </p>
            ))}
            <Button onClick={() => handleClear("locations")}>X</Button>
          </Badge>
        </Col>
      )}
      {jobTypes.length > 0 && (
        <Col xs="auto">
          <Badge pill>
            <h6>Job Type:</h6>
            {jobTypes.map((type, index) => (
              <p key={index}>
                {type} {index < jobTypes.length - 1 && <span>,</span>}
              </p>
            ))}
            <Button onClick={() => handleClear("jobTypes")}>X</Button>
          </Badge>
        </Col>
      )}
      {checkFilterActive() && (
        <Col xs="auto">
          <Button onClick={() => handleClear("all")}>Clear All</Button>
        </Col>
      )}
    </Row>
  );
}
